<!-- View Driver HTML starts here -->
<div class="view_driver_details_page">
  <div class="col-md-12" *ngIf="isLoading">
    <app-busy [message]="message"></app-busy>
  </div>
  <div>
    <fieldset class="carrier_details">
      <legend class="header">Carrier Details</legend>
      <div class="detail_row">
        <div class="column">Company registered name:</div>
        <div class="column">{{ carrierDetails.registered_name }}</div>
      </div>
      <div class="detail_row">
        <div class="column">Company registered number:</div>
        <div class="column">{{ carrierDetails.registration_number }}</div>
      </div>
      <div class="detail_row">
        <div class="column">Trading name:</div>
        <div class="column">{{ carrierDetails.trading_name }}</div>
      </div>
      <div class="detail_row">
        <div class="column">Type of carrier:</div>
        <div class="column">{{ carrierDetails.freight_passenger_ind }}</div>
      </div>
      <div class="detail_row">
        <div class="column">Email Address:</div>
        <div class="column">{{ carrierDetails.email }}</div>
      </div>
      <div class="detail_row">
        <div class="column">Telephone:</div>
        <div class="column">
          {{ carrierDetails.dial_code_tele }} {{ carrierDetails.telephone }}
        </div>
      </div>
      <div class="detail_row">
        <div class="column">Cellphone:</div>
        <div class="column">
          {{ carrierDetails.dial_code_cell }} {{ carrierDetails.cellphone }}
        </div>
      </div>
    </fieldset>

    <fieldset class="carrier_details">
      <legend class="header">Carrier Details</legend>
      <div class="detail_row">
        <div class="column">Company registered name:</div>
        <div class="column">{{ carrierDetails.registered_name }}</div>
      </div>
      <div class="detail_row">
        <div class="column">Company registered number:</div>
        <div class="column">{{ carrierDetails.registration_number }}</div>
      </div>
      <div class="detail_row">
        <div class="column">Trading name:</div>
        <div class="column">{{ carrierDetails.trading_name }}</div>
      </div>
      <div class="detail_row">
        <div class="column">Type of carrier:</div>
        <div class="column">
          {{ carrierDetails.freight_passenger_ind | carrierType }}
        </div>
      </div>
      <div class="detail_row">
        <div class="column">Email Address:</div>
        <div class="column">{{ carrierDetails.email }}</div>
      </div>
      <div class="detail_row">
        <div class="column">Telephone:</div>
        <div class="column">
          {{ carrierDetails.dial_code_tele }} {{ carrierDetails.telephone }}
        </div>
      </div>
      <div class="detail_row">
        <div class="column">Cellphone:</div>
        <div class="column">
          {{ carrierDetails.dial_code_cell }} {{ carrierDetails.cellphone }}
        </div>
      </div>
    </fieldset>
    <fieldset class="carrier_details">
      <legend class="header">
        <span>Driver Info</span>
        <!-- <div class="button_icons">
          <button
            type="button"
            class="icon_button"
            (click)="onDeleteDriver(driverDetails)"
          >
            <img src="assets/delete.png" alt="" /> Delete
          </button>
        </div> -->
      </legend>
      <div class="detail_row">
        <div class="column">Depot ID:</div>
        <div class="column">{{ driverDetails.depot_id }}</div>
      </div>
      <div class="detail_row">
        <div class="column">ID Type:</div>
        <div class="column">{{ driverDetails.id_type_ind }}</div>
      </div>
      <div class="detail_row">
        <div class="column">Passport Country ID:</div>
        <div class="column">{{ driverDetails.passport_country_id }}</div>
      </div>
      <div class="detail_row">
        <div class="column">Passport Number:</div>
        <div class="column">{{ driverDetails.passport_number }}</div>
      </div>
      <div class="detail_row">
        <div class="column">Passport expiry date:</div>
        <div class="column">{{ driverDetails.passport_expiry_date }}</div>
      </div>
      <div class="detail_row">
        <div class="column">First Name:</div>
        <div class="column">{{ driverDetails.first_name }}</div>
      </div>
      <div class="detail_row">
        <div class="column">Last Name:</div>
        <div class="column">{{ driverDetails.last_name }}</div>
      </div>
      <div class="detail_row">
        <div class="column">Date of birth:</div>
        <div class="column">{{ driverDetails.date_of_birth | date }}</div>
      </div>
      <div class="detail_row">
        <div class="column">Gender:</div>
        <div class="column">{{ driverDetails.gender }}</div>
      </div>
      <div class="detail_row">
        <div class="column">Cell Phone:</div>
        <div class="column">
          {{ driverDetails.dial_code_cell }} {{ driverDetails.cellphone }}
        </div>
      </div>
      <div class="detail_row">
        <div class="column">Traffic register number:</div>
        <div class="column">{{ driverDetails.traffic_register_number }}</div>
      </div>
      <div class="detail_row">
        <div class="column">License Type:</div>
        <div class="column">{{ driverDetails.license_type }}</div>
      </div>
      <div class="detail_row">
        <div class="column">License Number:</div>
        <div class="column">{{ driverDetails.license_number }}</div>
      </div>
      <div class="detail_row">
        <div class="column">Trn issue date:</div>
        <div class="column">{{ driverDetails.trn_issue_date }}</div>
      </div>
      <div class="detail_row">
        <div class="column">Work permit number:</div>
        <div class="column">{{ driverDetails.work_permit_number }}</div>
      </div>
      <div class="detail_row">
        <div class="column">Work expiry date:</div>
        <div class="column">{{ driverDetails.work_permit_expiry_date }}</div>
      </div>
      <div class="detail_row">
        <div class="column">Notes:</div>
        <div class="column">{{ driverDetails.notes }}</div>
      </div>
      <table style="width: 100%">
        <tr *ngFor="let Document of viewDocuments">
          <td>
            <div class="card">
              <h5 class="card-title">Files Uploaded</h5>

              <div class="card-body">
                <!-- <h2>Files Uploaded(0)</h2> -->

                <div class="row">
                  <div class="col-sm bg-light">
                    {{ Document.file_name }}
                  </div>
                  <div class="col-sm bg-light">PDF</div>
                  <div class="col-sm bg-light">
                    <span style="float: right !important">
                      <div class="file-upload-icons-group">
                        <a><img title="View Document" class="file-upload-icon" src="/assets/visibility.png"
                            alt="visibility" data-toggle="modal" data-target="#depotViewDoc1" (click)="
                            viewDoc(
                              Document.document_type_id,
                              Document.document_link
                                        )
                                      " /></a>
                        
                      </div>
                      <!-- <span title="Upload another of the same type" *ngIf="UserDocument.multiple_allowed == true" class="btn btn-primary btn-sm"><i
                          class="fa fa-plus" aria-hidden="true" (click)="extraDoc(UserDocument)"></i></span> -->
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </td>

          <td></td>
        </tr>
      
      </table>
    </fieldset>
    <div class="action_btns">
      <div class="btn_wrap">
        <button type="submit" (click)="back()" class="btn btn_primary">
          Done
        </button>
      </div>
    </div>
  </div>
</div>
<!-- View Driver HTML ends here -->


<div
  class="modal fade"
  id="depotViewDoc1"
  tabindex="-1"
  role="dialog"
  aria-labelledby="exampleModalLongTitle"
  aria-hidden="true"
>
<div class="modal-dialog modal-lg" tabindex="-1" aria-hidden="true" role="document">
  <div class="modal-content">
      <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">Depot Document View</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>
      </div>
      <div class="modal-body modal-lg">
        <div style="width: 99%; min-height: 470px">
          <pdf-viewer
            *ngIf="pdfSrc"
            [src]="pdfSrc"
            [render-text]="true"
            style="display: block"
            [original-size]="false"
            [autoresize]="true"
          ></pdf-viewer>
          <ngx-loading [show]="isLoading"></ngx-loading>
        </div>
      </div>
      <div class="modal-footer">
          <button type="button" class="btn pull-right btn_secondary" data-dismiss="modal">Close</button>
           <!-- <button type="button" class="btn btn-primary">Save changes</button>  -->
</div>
</div>
</div>
</div>